import { render, staticRenderFns } from "./Mastitis.vue?vue&type=template&id=09890c13&scoped=true&"
import script from "./Mastitis.vue?vue&type=script&lang=js&"
export * from "./Mastitis.vue?vue&type=script&lang=js&"
import style0 from "./Mastitis.vue?vue&type=style&index=0&id=09890c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09890c13",
  null
  
)

export default component.exports